import api from "../../helpers/api";


export const getCustomerArtisanFollowingList = (id) => api.get(`customer/${id}`)

export const removeCustomerArtisanFollow = (body) => api.post(`artisan/rem-follower/`, {...body})